// extracted by extract-css-chunks-webpack-plugin
module.exports = {"title":"_2fV_ju","listGrid":"_1zzmdL"};